<style lang="scss" scoped>
    .label_switch {
        display: inline-block;
        margin: 0;
        cursor: pointer;
        font-weight: normal;
        position: relative;

        input[type="checkbox"] {
            position: absolute;
            -webkit-appearance: none;
            appearance: none;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            margin: 0;
            opacity: 0;
            cursor: pointer;

            + span {
                display: inline-block;
                width: 40px;
                height: 22px;
                position: relative;

                &:before {
                    content: "";
                    display: block;
                    width: 38px;
                    height: 22px;
                    border-radius: 20px;
                    border: 1px solid #dfdfdf;
                    -webkit-transition: all 0.1s ease-out;
                    transition: all 0.1s ease-out;
                }
            }
        }

        &:hover input[type="checkbox"],
        input[type="checkbox"]:focus {
            + span:before {
                box-shadow: inset 0 0 15px #eee;
            }
        }

        input[type="checkbox"] {
            + span:after {
                content: "";
                position: absolute;
                top: 0px;
                left: 0;
                display: block;
                width: 22px;
                height: 22px;
                background: #fff;
                border-radius: 20px;
                border: solid 1px #dfdfdf;
                box-shadow: 2px 1px 1px -2px rgba(0,0,0,0.4);
                -webkit-transition: all 0.3s ease-out;
                transition: all 0.3s ease-out;
            }

            &:checked + span:after {
                left: 18px;
                border: solid 1px #5FBEAA;
                box-shadow: none;
            }

            &:checked + span:before,
            &:disabled:checked + span:before {
                border: 1px solid #5FBEAA;
                box-shadow: none;
                background-color: #5FBEAA;
            }
        }

        &:hover input[type="checkbox"]:checked + span:before {
            box-shadow: none;
        }

        input[type="checkbox"] {
            &:disabled + span {
                opacity: 0.6;

                &:before {
                    background-color: #f7f7f7;
                }

                &:after {
                    background-color: #fff;
                }

                &:before,
                &:after {
                    box-shadow: none;
                    cursor: no-drop;
                }
            }
        }

        &.switch_text_left span {
            float: left;
            margin: -2px 10px 0 0;
        }
    }
</style>

<template>
    <label class="label_switch">
        <input type="checkbox" ref="input" :disabled="disabled">
        <span class=""></span>
        {{ text }}
    </label>
</template>

<script>
    export default {
        props: {
            'value': {
                default: () => null
            },
            'text': {
                default: () => null
            },
            'disabled': {
                default: () => false
            }
        },
        watch: {
            value (value) {
                this.$refs.input.checked = value ? 1 : 0
            }
        },
        mounted () {
            this.$refs.input.checked = this.value ? 1 : 0

            this.$refs.input.addEventListener('change', () => {
                this.$emit('input', this.$refs.input.checked ? 1 : 0)
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/form/Switch.vue